webpackJsonp([266772403791747],{

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImgix = __webpack_require__(24);
	
	var _reactImgix2 = _interopRequireDefault(_reactImgix);
	
	var _helperFunctions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Builds Our Events, Our Services, etc blocks that fall under 'Our Mission' block
	var PageQueryAbstractPhoto = function PageQueryAbstractPhoto(_ref) {
	  var page = _ref.page,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    {
	      to: (0, _helperFunctions.endSlash)(page.route),
	      className: "abstract-photo-query " + className + " db flex flex-column w-100 justify-end bg-blue relative"
	    },
	    page.abstractPhoto && _react2.default.createElement(_reactImgix2.default, {
	      type: "img",
	      src: (0, _helperFunctions.endSlash)(page.abstractPhoto.url),
	      className: "abstract-photo-query__photo absolute top-0 left-0 mb0 image-cover w-100 h-100",
	      imgixParams: {
	        "max-w": 2732,
	        "fp-x": page.abstractPhotoFocalPointX,
	        "fp-y": page.abstractPhotoFocalPointY,
	        auto: ["compress"],
	        fit: "crop",
	        crop: "focalpoint"
	      },
	      htmlAttributes: {
	        alt: page.abstractPhotoAltText
	      }
	    }),
	    _react2.default.createElement(
	      "div",
	      { className: "abstract-photo-query__title bg-white flex items-center center-text justify-center" },
	      _react2.default.createElement(
	        "h4",
	        { className: "p-emphasis dark mb0 ttu" },
	        page.title
	      )
	    )
	  );
	};
	
	exports.default = PageQueryAbstractPhoto;
	module.exports = exports["default"];

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Icon = __webpack_require__(14);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Buttons = __webpack_require__(36);
	
	var _helperFunctions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Builds Explore Downtown, Live Downtown, etc colored blocks
	var StatQuery = function StatQuery(_ref) {
	  var page = _ref.page,
	      className = _ref.className,
	      direction = _ref.direction;
	
	  // page and direction are required
	  // className can be used for background color and spacing
	  var titleParts = page.title.split(" ");
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    {
	      to: (0, _helperFunctions.endSlash)(page.route),
	      className: "stat-query " + className + " flex justify-center-l db w-100 white flex flex-column justify-between relative"
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "stat-query__inner flex flex-column justify-between h-100 relative w-100" },
	      _react2.default.createElement(
	        "h5",
	        { className: "h-4 h-3--l ttu mb0 tc-l" },
	        titleParts[0],
	        _react2.default.createElement("br", null),
	        titleParts[1]
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "stat-query__illustration" },
	        _react2.default.createElement(_Icon2.default, { path: "illi-" + titleParts[0].toLowerCase(), className: "flex" })
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "dn db-l p mb0 tc mb3-l" },
	        page.abstract
	      ),
	      _react2.default.createElement(_Buttons.ButtonTextNoLink, { className: "dn db-l white" }),
	      _react2.default.createElement(_Icon2.default, { path: "arrow-right", height: "18", width: "32", className: "flex" })
	    )
	  );
	};
	
	exports.default = StatQuery;
	module.exports = exports["default"];

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.StatQuery = exports.PageQueryAbstractPhoto = undefined;
	
	var _PageQueryAbstractPhoto = __webpack_require__(239);
	
	var _PageQueryAbstractPhoto2 = _interopRequireDefault(_PageQueryAbstractPhoto);
	
	var _StatQuery = __webpack_require__(240);
	
	var _StatQuery2 = _interopRequireDefault(_StatQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components that are unique to the homepage
	
	exports.PageQueryAbstractPhoto = _PageQueryAbstractPhoto2.default;
	exports.StatQuery = _StatQuery2.default;

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/virtual-tour-abstract.b9d55c82.jpg";

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.previewQuery = exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImgix = __webpack_require__(24);
	
	var _reactImgix2 = _interopRequireDefault(_reactImgix);
	
	var _Meta = __webpack_require__(6);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _Banners = __webpack_require__(11);
	
	var _virtualTourAbstract = __webpack_require__(350);
	
	var _virtualTourAbstract2 = _interopRequireDefault(_virtualTourAbstract);
	
	var _FooterMap = __webpack_require__(50);
	
	var _FooterMap2 = _interopRequireDefault(_FooterMap);
	
	var _HomeHelpers = __webpack_require__(241);
	
	var _PageHelpers = __webpack_require__(25);
	
	var _helperFunctions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home(_ref) {
	  var data = _ref.data;
	
	  var page = data.mortyPage;
	  var block1 = page.childrenMortyBlock[0];
	  var block2 = page.childrenMortyBlock[1];
	  var featuredInterior = data.canalCruises.edges[0].node;
	  var featuredEventsPage = data.featuredEventsPage.edges[0].node;
	  var exploreDowntown = data.exploreDowntown.edges[0].node;
	  var liveDowntown = data.liveDowntown.edges[0].node;
	  var workDowntown = data.workDowntown.edges[0].node;
	  var ourEvents = data.ourEvents.edges[0].node;
	  var ourServices = data.ourServices.edges[0].node;
	  var aboutUs = data.aboutUs.edges[0].node;
	  var news = data.news.edges[0].node;
	  var allNews = data.allNews ? data.allNews.edges.map(function (d) {
	    return d.node;
	  }) : null;
	  var orderedNews = allNews ? (0, _helperFunctions.findRecentStories)(allNews) : null;
	  var mostRecentNews = orderedNews ? orderedNews[0] : null;
	  var ventureEvents = data.ventureEvents.edges.map(function (d) {
	    return d.node;
	  });
	  var orderedVentureEvents = (0, _helperFunctions.findRecentEvents)(ventureEvents);
	  var mostRecentVentureEvent = orderedVentureEvents[0];
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'home' },
	    _react2.default.createElement(_Meta2.default, { page: page }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Banners.HomepageBanner, { page: page, exploreDowntown: exploreDowntown }),
	      _react2.default.createElement(_PageHelpers.PageQueryBannerPhoto, { page: featuredInterior }),
	      mostRecentNews && _react2.default.createElement(_PageHelpers.FeedQueryUp, {
	        page: mostRecentNews,
	        className: 'mv3 mv5-l',
	        secondaryLink: news
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex flex-column items-center' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'p-emphasis p-lead-spaced--l dark mb0 ttu tc mh2 mw-696' },
	          'Downtown RVA'
	        ),
	        _react2.default.createElement('h4', {
	          className: 'p-emphasis p-lead-spaced--l grey1 mb0 ttu tc mh2 mw-696',
	          dangerouslySetInnerHTML: { __html: block1.content }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex flex-column flex-row-l justify-between-l w-100 mw-1060 mt2-l mb3 mb5-l' },
	          _react2.default.createElement(_HomeHelpers.StatQuery, { page: exploreDowntown, className: 'bg-blue' }),
	          _react2.default.createElement(_HomeHelpers.StatQuery, { page: liveDowntown, className: 'bg-green mt1 mt0-l' }),
	          _react2.default.createElement(_HomeHelpers.StatQuery, { page: workDowntown, className: 'bg-brick mt1 mt0-l' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex flex-column items-center bg-stone pv3 pv5-l' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'p-emphasis p-lead-spaced--l dark mb0 ttu tc mh2 mw-696' },
	          'Our Mission'
	        ),
	        _react2.default.createElement('h4', {
	          className: 'p-emphasis p-lead-spaced--l grey1 mb0 ttu tc mh2 mw-696',
	          dangerouslySetInnerHTML: { __html: block2.content }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'w-100 ph2 ph0-l mw-1060 flex flex-column flex-row-l items-center justify-between-l pt2-l' },
	          _react2.default.createElement(_HomeHelpers.PageQueryAbstractPhoto, { page: ourEvents }),
	          _react2.default.createElement(_HomeHelpers.PageQueryAbstractPhoto, {
	            page: ourServices,
	            className: 'mt1 mt0-l'
	          }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: '/live-downtown/virtual-tour/',
	              className: 'abstract-photo-query mt1 mt0-l db flex flex-column w-100 justify-end bg-blue relative'
	            },
	            _react2.default.createElement(_reactImgix2.default, {
	              type: 'img',
	              src: _virtualTourAbstract2.default,
	              className: 'abstract-photo-query__photo absolute top-0 left-0 mb0 image-cover w-100 h-100',
	              imgixParams: {
	                'max-w': 2732,
	                'fp-x': page.abstractPhotoFocalPointX,
	                'fp-y': page.abstractPhotoFocalPointY,
	                auto: ['compress'],
	                fit: 'crop',
	                crop: 'focalpoint'
	              },
	              htmlAttributes: {
	                alt: 'Virtual Tour'
	              }
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'abstract-photo-query__title bg-white flex items-center center-text justify-center' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'p-emphasis dark mb0 ttu' },
	                'Virtual Tour'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_PageHelpers.FeedQueryDown, {
	        page: mostRecentVentureEvent,
	        className: 'mv3 mv5-l',
	        secondaryLink: featuredEventsPage
	      }),
	      _react2.default.createElement(_FooterMap2.default, {
	        address: 'Brown\'s Island Richmond, VA 23219',
	        text: 'The Downtown Map',
	        text2: 'LEARN EVEN MORE ABOUT WHERE TO GO AND WHAT TO DO DOWNTOWN!'
	      })
	    )
	  );
	};
	
	exports.default = Home;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	var previewQuery = exports.previewQuery = '\n  query Home($id: String!) {\n    mortyPage(id: { eq: $id }) {\n      title\n      route\n      metaTitle\n      metaDescription\n      metaKeywords\n      bannerImageAltText\n      abstractPhotoAltText\n      bannerImageFocalPointX\n      bannerImageFocalPointY\n      abstractPhotoFocalPointX\n      abstractPhotoFocalPointY\n      bannerImage {\n        url\n      }\n      childrenMortyBlock {\n        id\n        blockType\n        content\n        headline\n        subheadline\n        buttonUrl\n        buttonTitle\n        format\n        caption\n        subcaption\n        url\n        attribution\n        focalPointX\n        focalPointY\n        altText\n        attributionAltText\n        attributionPhoto {\n          url\n        }\n        image {\n          url\n        }\n        videoType\n        videoMinutes\n        embedCode\n        attribution\n        attributionPhoto {\n          url\n        }\n        vistityUrl\n        vistityTitle\n      }\n    }\n    allMortyStory {\n      edges {\n        node {\n          id\n          title\n          route\n          abstractPhotoAltText\n          abstractPhotoFocalPointX\n          abstractPhotoFocalPointY\n          abstractPhoto {\n            url\n          }\n          publishedDate\n        }\n      }\n    }\n    canalCruises: allMortyPage(\n      filter: { route: { eq: "/our-services/riverfront-canal-cruises/" } }\n    ) {\n      edges {\n        node {\n          id\n          title\n          route\n          bannerImageAltText\n          bannerImageFocalPointX\n          bannerImageFocalPointY\n          bannerImage {\n            url\n          }\n        }\n      }\n    }\n    featuredEventsPage: allMortyPage(\n      filter: { route: { eq: "/our-events/featured-events/" } }\n    ) {\n      edges {\n        node {\n          id\n          title\n          route\n        }\n      }\n    }\n    exploreDowntown: allMortyPage(\n      filter: { route: { eq: "/explore-downtown/" } }\n    ) {\n      edges {\n        node {\n          id\n          title\n          route\n          abstract\n        }\n      }\n    }\n    liveDowntown: allMortyPage(filter: { route: { eq: "/live-downtown/" } }) {\n      edges {\n        node {\n          id\n          title\n          abstract\n          route\n        }\n      }\n    }\n    workDowntown: allMortyPage(filter: { route: { eq: "/work-downtown/" } }) {\n      edges {\n        node {\n          id\n          title\n          abstract\n          route\n        }\n      }\n    }\n    ventureEvents: allMortyEvent(filter: { tags: { eq: "Venture Richmond" } }) {\n      edges {\n        node {\n          id\n          title\n          route\n          eventDate\n          endDate\n          startTime\n          abstractPhotoAltText\n          abstractPhotoFocalPointX\n          abstractPhotoFocalPointY\n          abstractPhoto {\n            url\n          }\n        }\n      }\n    }\n    ourEvents: allMortyPage(filter: { route: { eq: "/our-events/" } }) {\n      edges {\n        node {\n          id\n          title\n          abstractPhotoAltText\n          abstractPhotoFocalPointX\n          abstractPhotoFocalPointY\n          abstractPhoto {\n            url\n          }\n          route\n        }\n      }\n    }\n    ourServices: allMortyPage(filter: { route: { eq: "/our-services/" } }) {\n      edges {\n        node {\n          id\n          title\n          abstractPhotoAltText\n          abstractPhotoFocalPointX\n          abstractPhotoFocalPointY\n          abstractPhoto {\n            url\n          }\n          route\n        }\n      }\n    }\n    aboutUs: allMortyPage(filter: { route: { eq: "/about-us/" } }) {\n      edges {\n        node {\n          id\n          title\n          abstractPhotoAltText\n          abstractPhotoFocalPointX\n          abstractPhotoFocalPointY\n          abstractPhoto {\n            url\n          }\n          route\n        }\n      }\n    }\n    allNews: allMortyStory(filter: { route: { ne: "/dummy-story" } }) {\n      edges {\n        node {\n          id\n          title\n          route\n          publishedDate\n          abstractPhotoAltText\n          abstractPhotoFocalPointX\n          abstractPhotoFocalPointY\n          abstractPhoto {\n            url\n          }\n        }\n      }\n    }\n    news: allMortyPage(filter: { route: { eq: "/news/" } }) {\n      edges {\n        node {\n          id\n          title\n          route\n        }\n      }\n    }\n  }\n';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-home-js-4c7bb107cc9446c4adae.js